import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import {withRouter} from 'react-router-dom';

@withRouter
@inject('resourcesStore')
@inject('userStore')
@observer
class ResourceItem extends PureComponent {
  onResourceEdit = resource => {
    this.props.history.push(`/resources/${resource.id}/edit`);
  };

  openDeleteConfirmModal = resource => {
    const {openDeleteModal} = this.props;

    openDeleteModal(resource);
  }

  render()  {
    const {resource, userStore} = this.props;
    const isAdmin = userStore.isAdmin();

    return (
      <div className="resource-item">
        <a
          href={`https://pharmacistexamprep.ie${resource.file_url}`}
          target='_blank'
        >
          <span>{resource.title}</span>
        </a>
        {isAdmin && (
          <div className="row">
            <button className="btn-new-main" onClick={() => this.onResourceEdit(resource)}>Edit</button>
            <button className="btn-new-red margin-left-20" onClick={() => this.openDeleteConfirmModal(resource)}>Delete</button>
          </div>
        )}
      </div>
    );
  }
}

export default ResourceItem;



// WEBPACK FOOTER //
// ./src/modules/resources/components/ResourceItem.js